// src/pages/RevisionList.jsx
import React, { useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { collection, getDocs, deleteDoc, doc } from "firebase/firestore";

import { db } from "../firebaseConfig";

export default function RevisionList() {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const cargarRevision = async () => {
      try {
        setLoading(true);
        setError("");

        const ref = collection(db, "revision");
        const snap = await getDocs(ref);

        const lista = snap.docs.map((docSnap) => {
          const data = docSnap.data();
          return {
            id: docSnap.id,
            usuarioId: data.usuarioId || "",
            cancionId: data.cancionId || "",
          };
        });

        setItems(lista);
      } catch (err) {
        console.error(err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    cargarRevision();
  }, []);

  const handleOpenSong = (item) => {
    if (!item.usuarioId || !item.cancionId) return;
    navigate(`/songs/${item.usuarioId}/${item.cancionId}`);
  };

const handleDelete = async (itemId) => {
    const ok = window.confirm("¿Seguro que quieres eliminar esta revisión?");
    if (!ok) return;

    try {
      await deleteDoc(doc(db, "revision", itemId));
      // Quitar de la lista en memoria
      setItems((prev) => prev.filter((it) => it.id !== itemId));
    } catch (err) {
      console.error(err);
      alert("Error al eliminar: " + err.message);
    }
  };


  if (loading) return <p>Cargando revisiones...</p>;
  if (error) return <p>Error: {error}</p>;

  return (
    <div>
      <Link to="/songs">← Ir a canciones</Link>

      <h1 style={{ marginTop: 16 }}>Pendientes de revisión</h1>
      <p style={{ marginBottom: 16 }}>Total: {items.length}</p>

      <div style={{ overflowX: "auto" }}>
        <table
          style={{
            width: "100%",
            borderCollapse: "collapse",
            fontSize: 14,
          }}
        >
          <thead>
            <tr>
              <th style={th}>#</th>
              <th style={th}>Usuario ID</th>
              <th style={th}>Canción ID</th>
              <th style={th}>Acciones</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item, idx) => (
                <tr
                key={item.id}
                onClick={() => handleOpenSong(item)}
                style={{
                    cursor:
                    item.usuarioId && item.cancionId ? "pointer" : "default",
                    backgroundColor: idx % 2 === 0 ? "#ffffff" : "#e0e0e0",
                }}
                >
                <td style={td}>{idx + 1}</td>
                <td style={td}>{item.usuarioId}</td>
                <td style={td}>{item.cancionId}</td>

                {/* ⬇️ NUEVA COLUMNA */}
                <td style={td}>
                    <button
                    onClick={(e) => {
                        e.stopPropagation();       // para que NO se abra SongDetail
                        handleDelete(item.id);
                    }}
                    >
                    Eliminar
                    </button>
                </td>
                </tr>
            ))}
            </tbody>

        </table>
      </div>

      <p style={{ marginTop: 8, fontSize: 12, color: "#777" }}>
        Al hacer clic en una fila se abre el detalle de la canción.
      </p>
    </div>
  );
}

const th = {
  borderBottom: "1px solid #ddd",
  textAlign: "left",
  padding: "8px",
  backgroundColor: "#f5f5f5",
};

const td = {
  borderBottom: "1px solid #eee",
  padding: "8px",
};
